import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router';
import { DetailsPage } from './View/DetailsPage';
import { Unauthenticated } from './Unauthenticated';
import { LandingPage } from './View/LandingPage';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import { LoadingScreen } from './LoadingScreen';
import { Box, Container } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/ReactToastify.css';
import { useAuth } from 'oidc-react';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '../store/slice/UserSlice';
import { AppDispatch, AppState } from 'store';
import { Unauthorized } from './UnAuthorized';
import ActionPanel from './Layouts/ActionPanel';
import { Logout } from './Logout';

const getMiddleContent = (token, user) => {
  if (!token) {
    return (
      <Routes>
        <Route path="/logout" element={<Logout />} />
        <Route path="*" element={<Unauthenticated />} />
      </Routes>
    );
  }
  if (user.details === null) {
    return (
      <Routes>
        <Route path="*" element={<Navigate to="/NotAuthorized" replace={true} />} />
        <Route path="/NotAuthorized" element={<Unauthorized />} />
        <Route path=":productId/:configurationId" element={<DetailsPage />} />
      </Routes>
    );
  } else {
    return (
      <>
        {user.details && (
          <Box className="secondaryHeader">
            <ActionPanel />
          </Box>
        )}
        <Routes>
          <Route path="/NotAuthenticated" element={<Unauthenticated />} />
          <Route path="/signin/oidc" element={<Navigate to="/" replace={true} />} />
          <Route path="/signin/oidc-silent" element={<Navigate to="/" replace={true} />} />
          <Route path="/" element={<Navigate to="/cva" />} />
          <Route path="cva" element={<LandingPage />} />
          <Route path=":productId/:configurationId" element={<DetailsPage />} />
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/logout" element={<Logout />} />
        </Routes>
      </>
    );
  }
};

function AppRoutes() {
  const dispatch = useDispatch<AppDispatch>();
  const auth = useAuth();
  const token = auth.userData?.access_token;

  const user = useSelector((state: AppState) => state.user);

  useEffect(() => {
    if (token) {
      dispatch(getUser());
    }
  }, [token]);

  return (
    <Container maxWidth={false} className="appRouter root">
      <Header />

      {getMiddleContent(token, user)}

      <Footer />
      <LoadingScreen />
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={true}
        closeOnClick={false}
        pauseOnHover
        theme="colored"
        draggable
      />
    </Container>
  );
}

export default AppRoutes;
